import Box from '@mui/material/Box/Box'
import CircularProgress from '@mui/material/CircularProgress/CircularProgress'
import { useEffect } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import NotificationItem from 'components/notifications/components/notification-card/NotificationItem'
import axAPI from 'httpConfig'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import '../../../../styles/notif.css'

const NotificationsCurrent = ({
	currentNotif,
	remove,
	setCurrentNotifications,
	setCountNotif,
	fetching,
	setOpenNotifications,
}) => {
	const messages = useAppSelector(
		state => state.websocketReducer.messageForNotifications,
	)

	useEffect(() => {
		if (messages !== null) {
			setCurrentNotifications(prevState => [messages, ...prevState])
		}
	}, [messages])

	const removeAllCurrentNotifications = () => {
		setCurrentNotifications([])
		axAPI({
			method: 'PATCH',
			url: `notifications/bulk`,
			data: { id: [], close_today: true, close_old: false },
		}).then(response => {
			if (response.status === 201)
				axAPI({
					method: 'GET',
					url: 'notifications/count',
				}).then(response => {
					setCountNotif(response.data.new_count)
				})
		})
	}
	return (
		<Box sx={{ marginBottom: '16px' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginBottom: '8px',
				}}
			>
				<TypographyPrimary sx={{ color: COLORS.secondary }}>
					Сегодня
				</TypographyPrimary>
				<TypographyPrimary
					sx={{ cursor: 'pointer', color: COLORS.secondary }}
					onClick={removeAllCurrentNotifications}
				>
					Очистить
				</TypographyPrimary>
			</Box>
			<TransitionGroup>
				{currentNotif.map(el => (
					<CSSTransition key={el.id} timeout={500} classNames={'notif'}>
						<NotificationItem
							remove={remove}
							{...el}
							setOpenNotifications={setOpenNotifications}
						/>
					</CSSTransition>
				))}
			</TransitionGroup>
			{fetching && (
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<CircularProgress
						sx={{
							'&.MuiCircularProgress-colorPrimary': { color: COLORS.main },
						}}
					/>
				</Box>
			)}
		</Box>
	)
}

export default NotificationsCurrent
